module.exports = __webpack_public_path__ + "img/substrate.cd77ec34.png";